import React from 'react';
import { withTranslation } from 'react-i18next';
import { st, classes } from '../Tabs/Tabs.st.css';

const Tab = ({ children, index, isSelected }) => (
  isSelected()&&
   <div
    inert
    id={`panel${index}`}
    data-name={`tabPanel_${index}`}
    data-role="tabPanel"
    role="tabpanel"
    className={
      st(classes.tabPanel) +
      ' ' +
      (!isSelected() ? st(classes.ariaHiddenTrue) : st(classes.ariaHiddenFalse))
    }
    aria-labelledby={`tab_${index}`}
    aria-hidden={!isSelected()}
  >
    {children}
  </div>
);

export default withTranslation()(Tab);
